import type { StyleLayer } from './utils/types'

export const layers_bikelanes_smooth_bad: StyleLayer[] = [
  {
    id: 'smoothness-badonly',
    type: 'line',
    filter: ['has', 'smoothness'],
    paint: {
      'line-color': [
        'match',
        ['get', 'smoothness'],
        ['bad'],
        '#d8035c',
        ['very_bad'],
        '#d8035c',
        'rgba(0, 0, 0, 0)',
      ],
      'line-dasharray': [1, 1],
      'line-offset': 1,
      'line-opacity': ['interpolate', ['linear'], ['zoom'], 8, 0, 8.1, 0.1, 8.5, 0.9],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 2, 14, 2.5, 16, 3],
    },
  },
]
